import classNames from 'classnames';

const MonitoringCategoryCard = ({ category, selected }: any) => {
	return (
		<div
			className={classNames(
				'flex justify-center items-center py-4 md:py-6 px-4 bg-main-bg rounded-lg shadow-lg transition-all duration-200',
				{
					'!bg-[#F5EFE9] shadow-xl': selected,
				}
			)}
		>
			<span className="font-bold text-sm md:text-base text-dark text-center line-clamp-2">
				{category?.check_up_category_name}
			</span>
		</div>
	);
};

export default MonitoringCategoryCard;
